import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { DeliveryOptionsEnum, } from '@as-react/common-types';
import { useAemConfig } from '@as-react/common-components';
import { CheckoutConfirmationOpeningHours } from './CheckoutConfirmationOpeningHours';
import StoreUtil from '../../../util/StoreUtil';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { isDaysOption } from '../../../util/BuyFormUtil';
import { formatTimeStampToDateString } from '../../../util/DateUtil';
import { Stack, TextAlpha } from '@yonderland/andes-react';
import { DeliveryAddressCard } from '../delivery/DeliveryAddressCard';
import { CheckoutConfirmationDeliveryStoreInfo } from './CheckoutConfirmationDeliveryStoreInfo';
const INTL_DATE_FORMAT = {
    weekday: 'long',
    day: '2-digit',
    month: 'long',
};
export const CheckoutConfirmationDeliveryMethodInfo = ({ deliveryInfo, order, store, isShoplanding, }) => {
    const { locale, mainWebShop } = useAemConfig();
    const { t } = useTranslation([I18N_NAMESPACES.buy, I18N_NAMESPACES.general]);
    const pickUpPoint = order.deliveryOption === DeliveryOptionsEnum.PICKUP_POINT;
    const collectStore = order.deliveryOption === DeliveryOptionsEnum.COLLECT_STORE;
    const collectHQ = order.deliveryOption === DeliveryOptionsEnum.COLLECT_HQ;
    const homeDelivery = isDaysOption(order.deliveryOption);
    const getDeliveryInfoAndText = () => {
        if (order.deliveryOption === DeliveryOptionsEnum.COLLECT_STORE) {
            return {
                before: deliveryInfo.clickAndCollectDeliveryInfo,
                after: deliveryInfo.emailPickupTextShop,
            };
        }
        if (order.deliveryOption === DeliveryOptionsEnum.PICKUP_POINT) {
            return {
                before: deliveryInfo.pickupPointDeliveryInfo,
                after: deliveryInfo.emailPickupTextPickupPoint,
            };
        }
        if (order.deliveryOption === DeliveryOptionsEnum.COLLECT_HQ) {
            return {
                before: `${t('buy:buy.payment.delivery.information.header.collecthq')}:`,
                after: '',
            };
        }
        return {
            before: deliveryInfo.homeDeliveryInfo,
            after: deliveryInfo.emailDispatchText,
        };
    };
    const hasDeliveryDate = order.deliveryDate || (order.deliveryDateFrom && order.deliveryDateTo);
    const getDeliveryMessage = () => {
        var _a, _b;
        const deliveryMessage = order.deliveryMessage ? order.deliveryMessage : '';
        if (collectStore && store) {
            return `${StoreUtil.getStoreName(store, mainWebShop, t)} ${deliveryMessage}`;
        }
        const pickUpPointMessage = pickUpPoint
            ? `${(_a = order.deliveryAddressResource) === null || _a === void 0 ? void 0 : _a.organisationName} ${(_b = order.deliveryAddressResource) === null || _b === void 0 ? void 0 : _b.locationName}. `
            : '';
        if (order.deliveryDate) {
            return `${pickUpPointMessage}${t('buy:buy.confirmation.delivery.information.promise.date', {
                date: formatTimeStampToDateString(order.deliveryDate, locale, INTL_DATE_FORMAT),
            })}.`;
        }
        if (order.deliveryDateFrom && order.deliveryDateTo) {
            if (order.deliveryDateFrom === order.deliveryDateTo) {
                return `${pickUpPointMessage}${t('buy:buy.confirmation.delivery.information.promise.date', {
                    date: formatTimeStampToDateString(order.deliveryDateTo, locale, INTL_DATE_FORMAT),
                })}.`;
            }
            return `${pickUpPointMessage}${t('buy:buy.confirmation.delivery.information.promise.daterange', {
                dateFrom: formatTimeStampToDateString(order.deliveryDateFrom, locale, INTL_DATE_FORMAT),
                dateTo: formatTimeStampToDateString(order.deliveryDateTo, locale, INTL_DATE_FORMAT),
            })}.`;
        }
        return deliveryMessage;
    };
    return (_jsxs(Stack, { direction: "col", gap: "4", children: [_jsx(TextAlpha, { children: isShoplanding ? (_jsxs(_Fragment, { children: [deliveryInfo.deliveryPromise && `${deliveryInfo.deliveryPromise} `, _jsx(TextAlpha, { as: "span", strong: true, color: "success", testId: "delivery-message", children: getDeliveryMessage() })] })) : (_jsxs(_Fragment, { children: [(!hasDeliveryDate || pickUpPoint) && getDeliveryInfoAndText().before, ' ', _jsx(TextAlpha, { as: "span", strong: true, color: "success", testId: "delivery-message", children: getDeliveryMessage() }), ' ', getDeliveryInfoAndText().after] })) }), !isShoplanding && (_jsxs(_Fragment, { children: [!collectStore && !collectHQ && (_jsx(DeliveryAddressCard, { address: order.deliveryAddressResource, pickUpPoint: pickUpPoint, hasStrongLocationName: pickUpPoint, title: homeDelivery ? t('buy.confirmation.delivery.address') : undefined })), pickUpPoint && order.locationDTO && _jsx(CheckoutConfirmationOpeningHours, { point: order.locationDTO }), collectStore && store && _jsx(CheckoutConfirmationDeliveryStoreInfo, { store: store })] }))] }));
};
